import { AnnualFee } from 'src/features/product-card/DriversLegacy/AnnualFee';
import { BalanceTransferFee } from 'src/features/product-card/DriversLegacy/BalanceTransferFee';
import { BalanceTransferIntroApr } from 'src/features/product-card/DriversLegacy/BalanceTransferIntroApr';
import { IntroApr } from 'src/features/product-card/DriversLegacy/IntroApr';
import { IntroOffer } from 'src/features/product-card/DriversLegacy/IntroOffer';
import { MinimumDeposit } from 'src/features/product-card/DriversLegacy/MinimumDeposit';
import { RecommendedCreditScore } from 'src/features/product-card/DriversLegacy/RecommendedCreditScore';
import { RecommendedCreditScoreSummaryTableTitle } from 'src/features/product-card/DriversLegacy/RecommendedCreditScore/SummaryTableTitle';
import { RegularApr } from 'src/features/product-card/DriversLegacy/RegularAPR';
import { RewardsRate } from 'src/features/product-card/DriversLegacy/RewardsRate';
import { Card } from './Card';
import { LearnMore } from './LearnMore';
import { Rating } from './Rating';
import { RatingTitle } from './Rating/RatingTitle';
import type { HeaderDetails } from './types';

export const sortConsideringExistence = (
  element1: number,
  element2: number,
  existenceChecker: (element: number | undefined) => boolean,
) => {
  const element1Exists = existenceChecker(element1);
  const element2Exists = existenceChecker(element2);
  if (element1Exists && element2Exists) {
    return element1 - element2;
  }
  return element1Exists ? -1 : 1;
};

export function getSortedRows<T extends { id: string }>(offers: T[], rowsOrder: string[]) {
  interface OrderMapping {
    [id: string]: number;
  }

  if (!rowsOrder.length) return offers;

  const orderMapping: OrderMapping = {};
  rowsOrder.forEach((id, index) => {
    orderMapping[id] = index;
  });

  return offers.toSorted((a, b) => {
    return sortConsideringExistence(
      orderMapping[a.id],
      orderMapping[b.id],
      element => element !== undefined,
    );
  });
}

export const HEADER_MAPPING: Record<string, HeaderDetails> = {
  card: { title: 'Credit card', component: Card },
  rating: {
    segmentAwareTitleAsComponent: RatingTitle,
    component: Rating,
  },
  annualFee: { title: 'Annual fee', component: AnnualFee },
  minimumDeposit: { title: 'Minimum deposit', component: MinimumDeposit },
  introApr: { title: 'Intro APR', component: IntroApr },
  regularApr: { title: 'Regular APR', component: RegularApr },
  learnMore: { title: 'Learn more', component: LearnMore },
  applyNow: { title: 'Apply now', component: LearnMore },
  rewardsRate: { title: 'Rewards rate', component: RewardsRate },
  introOffer: { title: 'Intro offer', component: IntroOffer },
  balanceTransferFee: { title: 'Balance transfer fee', component: BalanceTransferFee },
  balanceTransferIntroApr: {
    title: 'Balance transfer intro APR',
    component: BalanceTransferIntroApr,
  },
  recCreditScore: {
    title: RecommendedCreditScoreSummaryTableTitle,
    component: RecommendedCreditScore,
  },
};

export const SECTION_POSITION = 2;
export const SECTION_NAME = 'roundup_summary_table';
